import { StorageManager } from './storageManager';
import Dexie, { type EntityTable } from 'dexie';

interface StorageEntry {
  id: string;
  value: any;
}

export class IndexDbStorageManager implements StorageManager {
  private readonly db: Dexie & {
    storage: EntityTable<StorageEntry, 'id'>;
  };

  constructor() {
    this.db = new Dexie('MinistryOfLand') as Dexie & {
      storage: EntityTable<StorageEntry, 'id'>;
    };
    this.db.version(1).stores({
      storage: 'id',
    });
  }

  async clearStorage(): Promise<void> {
    await this.db.storage.clear();
  }

  async remove(key: string): Promise<void> {
    await this.db.storage.delete(key);
  }

  async persist(key: string, value: any): Promise<void> {
    await this.db.storage.put({
      id: key,
      value,
    });
  }

  async retrieve(key: string): Promise<any | null> {
    const entry = await this.db.storage.get(key);
    return entry?.value ?? null;
  }
}
